
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 13.688c-.061 1.543-1.347 2.853-3.07 2.811-.401-.01-.897-.15-1.887-.429-2.385-.673-4.455-1.803-4.952-4.335-.091-.466-.091-.99-.091-2.037V8.302c0-1.047 0-1.571.091-2.037.497-2.532 2.567-3.662 4.952-4.335.99-.28 1.486-.42 1.887-.429 1.723-.042 3.009 1.268 3.07 2.812","stroke":"#141B34","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M16.5 9H7.335m9.167 0c0-.584-1.662-1.674-2.084-2.083M16.501 9c0 .584-1.662 1.674-2.084 2.083","stroke":"#141B34","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    